import Button from "@mui/material/Button";
import penaltyToggleIcon from "../../assets/icons/penaltyToggle.png";
import Switch from "@mui/material/Switch";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadPenaltyToggleState } from "store/features/analysisResultsSlice";

function PenaltyToggleComponent() {
    const dispatch = useDispatch();

    const penaltyToggle = useSelector((state) => state.analysisResultsStore.penaltyToggle);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    if (!isHairCare && !isSkinCare && !isUnileverFragranceHouse) return null;

    const handlePenaltyToggleChange = () => {
        dispatch(loadPenaltyToggleState(!penaltyToggle));
    };

    return (
        <Button
            size="small"
            className={"custom-btn custom-btn-outlined-2 color-blue me-4 bold-content"}
            variant="outlined"
            startIcon={
                <img
                    style={{ height: "18px" }}
                    src={penaltyToggleIcon}
                />
            }
        >
            Penalty Analysis
            <Switch
                size="small"
                checked={penaltyToggle}
                onChange={handlePenaltyToggleChange}
            />
        </Button>
    );
}

export default PenaltyToggleComponent;
